import { create } from 'zustand';

import { enterpriseApi } from '@/api';

interface FirmStore {
  needRefeshBotList: boolean;
  setNeedRefeshBotList: (needRefeshBotList: boolean) => void;
  refeshFirmSider: boolean;
  setRefeshFirmSider: (refesh: boolean) => void;
  firmList: any[];
  firmData: {
    remainPersonalAuthCount: number;
    remainFullAuthCount: number;
  };
  getFirmList: () => void;
  showAccreditVisible: boolean;
  setShowAccreditVisible: (showAccreditVisible: boolean) => void;
}

export const useFirmStore = create<FirmStore>(set => ({
  // 剩余创建次数
  firmData: {
    remainPersonalAuthCount: 0,
    remainFullAuthCount: 0,
  },
  // 企业列表
  firmList: [],
  // 是否需要刷新智能体列表
  needRefeshBotList: false,
  // 是否需要企业版侧边栏
  refeshFirmSider: false,
  // 是否显示整体企业授权
  showAccreditVisible: false,

  getFirmList: () => {
    enterpriseApi.feimaChatEnterpriseSwitchList().then(res => {
      const { list, remainPersonalAuthCount, remainFullAuthCount } = res;
      set({
        firmList: list,
        firmData: {
          remainPersonalAuthCount,
          remainFullAuthCount,
        },
      });
    });
  },

  setNeedRefeshBotList: (needRefeshBotList: boolean) => {
    set({ needRefeshBotList });
  },

  setRefeshFirmSider: (refesh: boolean) => {
    set({ refeshFirmSider: refesh });
  },

  setShowAccreditVisible: (showAccreditVisible: boolean) => {
    set({ showAccreditVisible });
  },
}));
